import { masks, onlyCnpjChars } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../core/MaskedField'

export function CnpjField(props: MaskedFieldProps) {
  return <MaskedField mask={masks.cnpj} placeholder='__.___.___ /____-__' parse={onlyCnpjChars} {...props} />
}
